import type { FC, PropsWithChildren } from 'react';

import ExploreBackground from '@/components/_explore/ExploreBackground.tsx';
import RegisteredWrapper from '@/components/RegisteredWrapper.tsx';
import type TranslationKey from '@/lib/i18n/TranslationKey.ts';
import useTitle from '@/lib/useTitle.ts';

import Footer from '../Footer.tsx';
import Header from '../Header/index.tsx';

type ExploreLayoutProps = {
  title: TranslationKey<['common', 'explore']>;
};
const ExploreLayout: FC<PropsWithChildren<ExploreLayoutProps>> = ({ title, children }) => {
  useTitle(title, undefined, ['common', 'explore']);

  return (
    <div className="vh-100 d-flex flex-column">
      <Header />
      <div className="position-relative d-flex flex-column flex-grow-1 pb-5">
        <ExploreBackground />
        <RegisteredWrapper>{children}</RegisteredWrapper>
      </div>
      <div className="flex-grow-0">
        <Footer />
      </div>
    </div>
  );
};

export default ExploreLayout;
